module.exports = __webpack_public_path__ + "img/img33.0924aca7.png";